import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import {
  NewsArticle,
  StrapiNewsArticle,
  mapStrapiArticle,
} from "../model";

interface StrapiResponse {
  data: StrapiNewsArticle[];
}

const STRAPI_NEWS_URL = `${process.env.REACT_APP_STRAPI_API_URL}/api/what-s-news`;

export const GetNewsArticlesApiService = async (): Promise<NewsArticle[]> => {
  const { data } = await axios.get<StrapiResponse>(STRAPI_NEWS_URL, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`,
    },
    params: {
      sort: "date:desc",
      populate: "*",
    },
  });
  return [...data.data]
    .sort(
      (a, b) =>
        new Date(b.attributes.date ?? b.attributes.publishedAt).getTime() -
        new Date(a.attributes.date ?? a.attributes.publishedAt).getTime()
    )
    .map(mapStrapiArticle);
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useGetNewsArticlesApiService = () =>
  useQuery<NewsArticle[], AxiosError>(
    ["GetNewsArticlesApiService"],
    () => GetNewsArticlesApiService(),
    { keepPreviousData: true }
  );
